import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { NavigationService } from '../../../core/service/navigation.service';
import { UserAccountService } from '../user-account.service';
import { ModuleNames } from '../../model/account-definition';

@Injectable()
export class MessagesGuard {
  constructor(
    private _userAccount: UserAccountService,
    private _navigation: NavigationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    return this._userAccount.current.pipe(
      map(account => {
        if (account.hasAccess(ModuleNames.Messages)) return true;

        this._navigation.navigatePageNotFound();
        return false;
      })
    );
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    return this.canActivate(childRoute, state);
  }
}
